import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { getS3 } from '../utils/Download';
// import Loader from '../../StaticComponent/Loader';

function CandidateOffer(props) {
    const [isLoading, setIsLoading] = React.useState(true);
    const offerData = props.offerDetails;
    let offer_pre_url;
    if(offerData?.url){
       offer_pre_url=getS3(offerData?.url)
    }
   


    const jobsData = props.jobDetails;
    const reportingDetails = props.reportingDetails;
    const rejectdata = props.rejectdetails;

    return (
        <div>
            <div className="row mb-4">
                <div className="col-md-12 mt-4">
                    <div className="card">
                        <div className="card-body p-4">
                            <p className="semibold-text font-16">Offer Details</p>
                            <div className="row">
                                {offerData?.offerletter_status !== 'Rejected' ? (
                                    <>
                                        <div className="col-md-3">
                                            <label className="w-100 recruit-summary-label regular-text">Status</label>
                                            <label className="recruit-accept regular-text">
                                                {offerData?.offerletter_status == '' ||
                                                offerData?.offerletter_status == null ||
                                                offerData?.offerletter_status == undefined
                                                    ? 'Offer Not Drafted'
                                                    : offerData.offerletter_status}
                                            </label>
                                        </div>
                                        <div className="col-md-3">
                                            <label className="w-100 recruit-summary-label regular-text">Accepted On</label>
                                            <label className="regular-text">
                                                {offerData.offerletter_status == 'Offer Accepted'
                                                    ? moment(offerData.modified_at).format('ll')
                                                    : '-'}
                                            </label>
                                        </div>
                                        <div className="col-md-3">
                                            <label className="w-100 recruit-summary-label regular-text">Onboarding Date</label>
                                            <label className="regular-text">
                                                {offerData.on_boarding_date == '' ? '-' : moment(offerData.on_boarding_date).format('ll')}
                                            </label>
                                        </div>
                                        <div className="col-md-3">
                                            <label className="w-100 recruit-summary-label regular-text">Annual Salary</label>
                                            <label className="regular-text">
                                                {offerData.annual_ctc == '' ? '-' : offerData.annual_ctc}
                                            </label>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="col-md-4">
                                            <label className="w-100 recruit-summary-label regular-text">Status</label>
                                            <label className="recruit-reject regular-text">
                                                {offerData?.offerletter_status == '' || offerData?.offerletter_status == null
                                                    ? 'Offer Not Drafted'
                                                    : offerData.offerletter_status}
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="w-100 recruit-summary-label regular-text">Rejected On</label>
                                            <label className="regular-text">
                                                {offerData?.modified_at == '' &&
                                                offerData?.on_boarding_date !== '' &&
                                                offerData?.on_boarding_date !== null
                                                    ? '-'
                                                    : moment(offerData.modified_at).format('ll')}
                                            </label>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="w-100 recruit-summary-label regular-text">Reason</label>
                                            <label className="regular-text">
                                                {rejectdata?.reason == '' || rejectdata?.reason == undefined || rejectdata?.reason == null
                                                    ? '-'
                                                    : rejectdata?.reason}
                                            </label>
                                        </div>
                                        <div className="mt-3">
                                            <div className="col-md-3">
                                                <label className="w-100 recruit-summary-label regular-text">Comments</label>
                                                <label className="regular-text">
                                                    {rejectdata?.detailed_reason == '' ||
                                                    rejectdata?.detailed_reason == undefined ||
                                                    rejectdata?.detailed_reason == null
                                                        ? '-'
                                                        : rejectdata?.detailed_reason}
                                                </label>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row ps-1 mb-5">
                <label className="font-16 bold-text mb-3">Employment Details</label>

                <div className="col-md-4">
                    <label className="form-label regular-text recruit-summary-label">Job Title</label>
                    <p className="recruit-label-clr regular-text mb-0">{jobsData.job_title}</p>
                </div>
                <div className="col-md-4">
                    <label className="form-label regular-text recruit-summary-label">Department</label>
                    <p className="recruit-label-clr regular-text mb-0">{jobsData.department}</p>
                </div>
                <div className="col-md-4">
                    <label className="form-label regular-text recruit-summary-label">Job Location</label>
                    <p className="recruit-label-clr regular-text mb-0">{jobsData.location}</p>
                </div>
                <div className="col-md-4 mt-4">
                    <label className="form-label regular-text recruit-summary-label">Employment Type</label>
                    <p className="recruit-label-clr regular-text mb-0">{jobsData.employment_type}</p>
                </div>
                <div className="col-md-4 mt-4">
                    <label className="form-label regular-text recruit-summary-label">Reporting Manager</label>
                    <p className="recruit-label-clr regular-text mb-0">
                        {reportingDetails.reportingManager == '' ? '-' : reportingDetails.reportingManager}
                    </p>
                </div>
                <div className="col-md-4 mt-4">
                    <label className="form-label regular-text recruit-summary-label">HR Partner</label>
                    <p className="recruit-label-clr regular-text mb-0">
                        {reportingDetails.HRPartner == '' ? '-' : reportingDetails.HRPartner}
                    </p>
                </div>
            </div>

            <div className="row ps-1">
                <label className="font-16 bold-text mb-3">Offer Information</label>
                <div className="col-md-4">
                    <label className="form-label regular-text recruit-summary-label">PDF</label>
                    <p className="recruit-label-clr regular-text mb-0">
                        {' '}
                        <a href={offer_pre_url} target="_blank" className="d-block font-13 color-darkblue bold-text text-decoration-none">
                            {offerData?.url?.split('/').pop()}
                        </a>
                    </p>
                </div>
                <div className="col-md-4">
                    <label className="form-label regular-text recruit-summary-label">Offer valid till</label>
                    <p className="recruit-label-clr regular-text mb-0">
                        {reportingDetails.offerValid == '' ? '-' : reportingDetails.offerValid}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default CandidateOffer;
